import React, { useEffect, useState } from 'react'
import classnames from 'classnames'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import UikInput from 'components/UikInput'
import { openNotificationWithMsg } from 'helpers'

const LocationAutoComplete = props => {
  const { searchType, resetLocationSearch, onInputChange, grabLocationSuccessFunction } = props

  useEffect(() => {
    if (resetLocationSearch) {
      setAddressChanged(false)
    }
  }, [resetLocationSearch])

  const [address, setAddress] = useState('')
  const [addressChanged, setAddressChanged] = useState(false)

  const handleChange = address => {
    setAddress(address)
    setAddressChanged(true)
    onInputChange(address)
  }

  const handleSelect = async address => {
    setAddress(address)
    try {
      const results = await geocodeByAddress(address)
      const locationDataObj = results[0]

      var latLng = await getLatLng(locationDataObj)
      latLng.location = locationDataObj
      grabLocationSuccessFunction(latLng)
    } catch (err) {
      handleError()
    }
  }

  const handleError = () => openNotificationWithMsg('error', 'Try again!')

  return (
    <div className="relative">
      <PlacesAutocomplete
        value={!addressChanged ? props.initialAddress : address}
        onChange={handleChange}
        onSelect={handleSelect}
        onError={handleError}
        debounce={500}
        shouldFetchSuggestions={address.length >= 1}
        searchOptions={{ types: [searchType] }}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <>
            <UikInput
              data-cy="location-input"
              focus={props.focus}
              className={props.showLocationSearch ? classnames(props.inputClassName) : 'hidden'}
              style={{ textAlign: 'center', ...props.inputStyles }}
              placeholder={props.needsPlaceholder ? 'Enter your city and country' : address}
              icon={props.icon}
              autoComplete="none" // A compromise as autocomplete="off" did not work, see:
              // https://stackoverflow.com/questions/15738259/disabling-chrome-autofill
              iconPosition={props.iconPosition}
              {...getInputProps({})}
            />
            {(!!suggestions.length || loading) && (
              <div className="autocomplete-dropdown-container absolute z-1000 w-full mt-2">
                {loading && <div className="p-4 bg-white text-black">Loading...</div>}
                {suggestions.map(suggestion => {
                  const activeClassName = suggestion.active
                    ? 'suggestion-item--active'
                    : 'suggestion-item'
                  const className = `${activeClassName} p-3`
                  // inline style for demonstration purpose
                  const style = suggestion.active
                    ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                    : { backgroundColor: '#ffffff', cursor: 'pointer' }
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  )
                })}
              </div>
            )}
          </>
        )}
      </PlacesAutocomplete>
    </div>
  )
}

LocationAutoComplete.defaultProps = {
  focus: true,
  inputStyles: {},
  searchType: '(cities)',
}
export default LocationAutoComplete
